// extracted by mini-css-extract-plugin
var _1 = "ServiceRequestsWidgetItemContent-moduleServiceRequestsWidgetItemContent__Jz_7m";
var _2 = "ServiceRequestsWidgetItemContent-moduledescription__sMVzM ListItemContent-moduledescription__jaeCE";
var _3 = "ServiceRequestsWidgetItemContent-modulestatus__lY3r9";
var _4 = "ServiceRequestsWidgetItemContent-moduletext__Fonv5 ListItemContent-moduletext__Rd9WF";
var _5 = "ServiceRequestsWidgetItemContent-moduletextContainer__zx8Cx ListItemContent-moduletextContainer__LZn5S";
export { _1 as "ServiceRequestsWidgetItemContent", _2 as "description", _3 as "status", _4 as "text", _5 as "textContainer" }
